import React from "react";

type Props = {};

export default function AssistantIcon({}: Props) {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        width="64"
        height="64"
        rx="10"
        fill="url(#paint0_radial_6321_4276)"
      />
      <path
        d="M41.5 30.9749V27.9999C41.5 27.4694 41.2893 26.9607 40.9142 26.5857C40.5391 26.2106 40.0304 25.9999 39.5 25.9999H33.5V24.6879C33.805 24.4139 34 24.0199 34 23.5779C34 23.1801 33.842 22.7985 33.5607 22.5172C33.2794 22.2359 32.8978 22.0779 32.5 22.0779C32.1022 22.0779 31.7206 22.2359 31.4393 22.5172C31.158 22.7985 31 23.1801 31 23.5779C31 24.0199 31.195 24.4139 31.5 24.6879V25.9999H25.5C24.9696 25.9999 24.4609 26.2106 24.0858 26.5857C23.7107 26.9607 23.5 27.4694 23.5 27.9999V30.9979L23.428 31.0029C23.1759 31.0208 22.94 31.1337 22.7677 31.3187C22.5955 31.5037 22.4999 31.7471 22.5 31.9999V33.9999C22.5 34.2651 22.6054 34.5195 22.7929 34.707C22.9804 34.8945 23.2348 34.9999 23.5 34.9999V39.9999C23.5 40.5303 23.7107 41.039 24.0858 41.4141C24.4609 41.7892 24.9696 41.9999 25.5 41.9999H39.5C40.0304 41.9999 40.5391 41.7892 40.9142 41.4141C41.2893 41.039 41.5 40.5303 41.5 39.9999V34.9999C41.7652 34.9999 42.0196 34.8945 42.2071 34.707C42.3946 34.5195 42.5 34.2651 42.5 33.9999V32.0619C42.5116 31.9067 42.4869 31.7509 42.428 31.6069C42.226 31.1189 41.793 31.0019 41.5 30.9749ZM27.5 31.9999C27.5 30.8959 28.172 29.9999 29 29.9999C29.828 29.9999 30.5 30.8959 30.5 31.9999C30.5 33.1039 29.828 33.9999 29 33.9999C28.172 33.9999 27.5 33.1039 27.5 31.9999ZM36.498 37.9999C35.497 37.9969 28.501 37.9999 28.5 37.9999V35.9999C28.5 35.9999 35.501 35.9979 36.502 35.9999L36.498 37.9999ZM36 33.9999C35.172 33.9999 34.5 33.1039 34.5 31.9999C34.5 30.8959 35.172 29.9999 36 29.9999C36.828 29.9999 37.5 30.8959 37.5 31.9999C37.5 33.1039 36.828 33.9999 36 33.9999Z"
        fill="#3654AF"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6321_4276"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.5 32) rotate(90) scale(32)"
        >
          <stop stopColor="#95AAE7" />
          <stop offset="1" stopColor="#AFC1F3" />
        </radialGradient>
      </defs>
    </svg>
  );
}
